import React from 'react';
import { Row, Col, Typography, Image, Divider } from 'antd';
import GlobeImage from '../../Assets/About/Scientific-Objectives-Earth.png';
import '../../Styles/AboutStyles.css';

const { Title, Paragraph } = Typography;

const objectives = [
  'To develop specialized scientific human resource and national capacity in the field of space science, technology and applications to carry out research and development in this growing scientific domain for the socio-economic uplift and development of Pakistan.',
  'To develop new and to upgrade existing models, maps, solutions, data, prototypes and products along with academic and research output in the areas of environment, climate, water, agriculture, geoscience, geo-health, geo-forensic, mineral inventory, positioning applications, small satellite development, computational and observational astronomy & astrophysics, space education and awareness.',
  'To design solutions for local users and taking them to market through technology commercialization, patenting and licensing and to develop National/International linkages, outreach and capacity building in the fields of GIS and Space Applications.',
  'To provide high-value shared services to academia, startups and private/public industrial partners.',
  'To create awareness among general masses about the bounties of space technology and its applications and to create a hub for hands-on training and workshops for students, academicians, professionals, entrepreneurs and public/private industry.',
];

const ScientificObjectives = () => (
  <section id="scientific-objectives" className="scientific-objectives-section">
    <Row gutter={[64, 40]} justify="space-between" align="middle">
      <Col xs={24} md={15}>
        <Title level={2} className="scientific-objectives-title">Scientific Objectives</Title>
        <Divider className="ncgsa-divider" />
        <Paragraph className="scientific-objectives-paragraph">
          With the development of NCGSA, we will achieve the following objectives:
        </Paragraph>
        <div className="scientific-objectives-list">
          {objectives.map((objective) => (
            <p className="scientific-objectives-text" key={objective}>{objective}</p>
          ))}
        </div>
      </Col>

      <Col xs={24} md={9}>
        <div className="scientific-objectives-image-container">
          <Image preview={false} src={GlobeImage} alt="Sustainable cities, agriculture, and natural ecosystems represented on Earth" className="scientific-objectives-image" />
        </div>
      </Col>
    </Row>
  </section>
);

export default ScientificObjectives;
